<template>
	<div id="header">
		{{data}}
	</div>
</template>
<script>
	import {
		apiurl,
		imgurl
	} from '../../common/js/baseApi.js'
	import axios from 'axios'
	export default {
		components: {},
		data() {
			return {
				data: null,
				pId: '' ,// 用户id
			}
		},
		computed: {},
		watch: {},
		methods: {
			getDeptName() {
				axios.get(apiurl + '/index/getDeptName', {
						params: {
							pId: this.pId
						}
					})
					.then(data => {
						console.log(data)
						if (data.data.status != 1) {
							return
						}
						
						this.data = data.data.data
					
					})
					.catch(err => {
			
					})
			}
		},
		created() {},
		mounted() {
			var url = window.location.search;
			var theRequest = new Object();
			if (url.indexOf("?") != -1) {
				var str = url.split('?')[1];
				var strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
				}
			}
			this.pId = theRequest.pId
			this.getDeptName()
		},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {},
	}
</script>
<style lang='scss' scoped>
	#header {
		width: 120rem;
		height: 7.5rem;
		background: url(../../common/img/header/bg.png) 0 0 no-repeat;
		background-size: 100% 100%;
		font-size: 3rem;
		color: #FFFFFF;
		display: flex;
		justify-content: center;
		line-height: 6rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue